import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="max-w-md mx-auto">
      <Outlet />
    </div>
  );
}
